import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';

import "core-js/modules/es.array.concat.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "content"
  }, [_c("div", [_c(VAutocomplete, {
    staticClass: "v-text-field-no-label required",
    attrs: {
      label: "Default consolidation/departure for continent",
      items: _vm.warehouses,
      disabled: _vm.isSavingDefaultDeparture,
      "hide-no-data": "",
      "hide-selected": "",
      "item-text": "name",
      "item-value": "id_warehouse"
    },
    on: {
      change: function change($event) {
        return _vm.updateContinentDeparture();
      }
    },
    model: {
      value: _vm.continentWarehouseId,
      callback: function callback($$v) {
        _vm.continentWarehouseId = $$v;
      },
      expression: "continentWarehouseId"
    }
  })], 1), _vm.countriesWarehouse.length > 0 ? _c("div", {
    staticClass: "flex flex-column justify-start items-start"
  }, [_c("div", {
    staticClass: "flex items-baseline justify-start gap-2"
  }, [_c(VIcon, {
    class: ["fa cursor--pointer", _vm.isShowExistingCountries ? "fa-eye-slash" : "fa-eye"],
    attrs: {
      size: "16"
    },
    on: {
      click: function click($event) {
        return _vm.toggleShowCountries();
      }
    }
  }), _c("span", {
    staticClass: "text-bold cursor--pointer",
    on: {
      click: function click($event) {
        return _vm.toggleShowCountries();
      }
    }
  }, [_vm._v(" Country precision : " + _vm._s(_vm.countriesWarehouse.length) + " ")])], 1), _vm.isShowExistingCountries ? _c("ul", {
    staticClass: "rm-margin"
  }, _vm._l(_vm.countriesWarehouse, function (item) {
    return _c("li", {
      key: "country-".concat(item.id),
      staticClass: "text-smaller"
    }, [_c("div", {
      staticClass: "flex items-center gap-4"
    }, [_c("div", [_vm._v(" " + _vm._s("".concat(item.countryName, " :")) + " ")]), _c("div", [_c(VAutocomplete, {
      staticClass: "v-text-field-no-label required",
      attrs: {
        items: _vm.warehouses,
        "hide-no-data": "",
        "hide-selected": "",
        "hide-details": "auto",
        "item-text": "name",
        "item-value": "id_warehouse"
      },
      on: {
        change: function change($event) {
          return _vm.updateDeparture(item);
        }
      },
      model: {
        value: item.warehouseId,
        callback: function callback($$v) {
          _vm.$set(item, "warehouseId", $$v);
        },
        expression: "item.warehouseId"
      }
    })], 1), _c("div", {
      staticClass: "flex items-center gap-2"
    }, [_c(VIcon, {
      staticClass: "cursor--pointer fa fa-trash",
      attrs: {
        disabled: item.isChanging,
        size: "12"
      },
      on: {
        click: function click($event) {
          return _vm.deleteDeparture(item);
        }
      }
    })], 1)])]);
  }), 0) : _vm._e()]) : _vm._e(), _vm.statesWarehouse.length > 0 ? _c("div", {
    staticClass: "flex flex-column justify-start items-start"
  }, [_c("div", {
    staticClass: "flex items-baseline justify-start gap-2"
  }, [_c(VIcon, {
    class: ["fa cursor--pointer", _vm.isShowExistingStates ? "fa-eye-slash" : "fa-eye"],
    attrs: {
      size: "16"
    },
    on: {
      click: function click($event) {
        return _vm.toggleShowStates();
      }
    }
  }), _c("span", {
    staticClass: "text-bold cursor--pointer",
    on: {
      click: function click($event) {
        return _vm.toggleShowStates();
      }
    }
  }, [_vm._v(" State precision : " + _vm._s(_vm.statesWarehouse.length) + " ")])], 1), _vm.isShowExistingStates ? _c("ul", {
    staticClass: "rm-margin"
  }, _vm._l(_vm.statesWarehouse, function (item) {
    return _c("li", {
      key: "states-".concat(item.id),
      staticClass: "text-smaller py-1"
    }, [_c("div", {
      staticClass: "flex items-center gap-4"
    }, [_c("div", [_vm._v(" " + _vm._s("".concat(item.countryName, ", ").concat(item.stateName, " :")) + " ")]), _c("div", [_c(VAutocomplete, {
      staticClass: "v-text-field-no-label required",
      attrs: {
        items: _vm.warehouses,
        "hide-no-data": "",
        "hide-selected": "",
        "hide-details": "auto",
        "item-text": "name",
        "item-value": "id_warehouse"
      },
      on: {
        change: function change($event) {
          return _vm.updateDeparture(item);
        }
      },
      model: {
        value: item.warehouseId,
        callback: function callback($$v) {
          _vm.$set(item, "warehouseId", $$v);
        },
        expression: "item.warehouseId"
      }
    })], 1), _c("div", {
      staticClass: "flex items-center gap-2"
    }, [_c(VIcon, {
      staticClass: "cursor--pointer fa fa-trash",
      attrs: {
        disabled: item.isChanging,
        size: "12"
      },
      on: {
        click: function click($event) {
          return _vm.deleteDeparture(item);
        }
      }
    })], 1)])]);
  }), 0) : _vm._e()]) : _vm._e(), _c(VDivider, {
    staticClass: "mb-2"
  }), _c("div", [_vm._v("Add new default consolidation/departure setting")]), _c("div", [_c(VAutocomplete, {
    staticClass: "v-text-field-no-label required",
    attrs: {
      label: "Country",
      items: _vm.listCountries,
      "hide-no-data": "",
      "hide-selected": "",
      "item-text": "printable_name",
      "item-value": "id_country",
      placeholder: "Type a country name"
    },
    model: {
      value: _vm.form.countryId,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "countryId", $$v);
      },
      expression: "form.countryId"
    }
  })], 1), _vm.displayedStatesList.length > 0 ? _c("div", [_c(VAutocomplete, {
    staticClass: "v-text-field-no-label",
    attrs: {
      label: "State",
      items: _vm.displayedStatesList,
      "hide-no-data": "",
      "hide-selected": "",
      "item-text": "state_label",
      "item-value": "id_state",
      clearable: ""
    },
    model: {
      value: _vm.form.stateId,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "stateId", $$v);
      },
      expression: "form.stateId"
    }
  })], 1) : _vm._e(), _c("div", [_c(VAutocomplete, {
    staticClass: "v-text-field-no-label required",
    attrs: {
      label: "Consolidation/Departure warehouse",
      items: _vm.warehouses,
      "hide-no-data": "",
      "hide-selected": "",
      "item-text": "name",
      "item-value": "id_warehouse"
    },
    model: {
      value: _vm.form.warehouseId,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "warehouseId", $$v);
      },
      expression: "form.warehouseId"
    }
  })], 1), _c("div", {
    staticClass: "action-add"
  }, [_c(VBtn, {
    staticClass: "dfwa-btn --small",
    attrs: {
      rounded: "",
      disabled: _vm.isInvalidForm,
      loading: _vm.isAdding
    },
    on: {
      click: function click($event) {
        return _vm.addDeparture();
      }
    }
  }, [_vm._v(" Create ")])], 1), _c("Confirm", {
    ref: "confirm"
  })], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };